import script from "./PublicDiscussionsList.vue?vue&type=script&setup=true&lang=js"
export * from "./PublicDiscussionsList.vue?vue&type=script&setup=true&lang=js"

import "./PublicDiscussionsList.vue?vue&type=style&index=0&id=1f1b2c6e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f1b2c6e"]])

export default __exports__